export const STATUSES = [
    { id: '5', name: 'Создан' },
    { id: '10', name: 'В пути' },
    { id: '9', name: 'Завершен' },
    { id: '14', name: 'Доставлен' }
]

export const STATUSES_RPK_RPP = [
    { id: '13', name: 'Подтвержден' },
    { id: '11', name: 'На проверке у РТО' },
    { id: '15', name: 'К оплате' },
]

export const LTLHintText =
    'Если нет нужного получателя, обратитесь в jira с просьбой создать Направление для текущего заказа'
